import styles from './styles.module.scss';
import { ReactComponent as ApproveIcon } from '../../shared/icons/approve-icon.svg';
import { ReactComponent as RejectIcon } from '../../shared/icons/remove-icon.svg';

export interface RequestData {
  id: string;
  memberName: string;
  status: string;
  handleAccess: { organizationRequestId: string };
}

interface MobileRequestItemProps {
  request: RequestData;
  onApprove: () => void;
  onReject: () => void;
  canApprove: boolean;
  canReject: boolean;
  hasPermission: boolean;
}

export const MobileRequestItem: React.FC<MobileRequestItemProps> = ({
  request,
  onApprove,
  onReject,
  canApprove,
  canReject,
  hasPermission,
}) => {
  return (
    <div className={styles.requestItem}>
      {/* Single row: Name (flexible), Status pill, Action buttons */}
      <div className={styles.requestItem__name}>{request.memberName}</div>
      <span className={`${styles.statusPill} ${styles[`statusPill--${request.status.toLowerCase()}`]}`}>
        {request.status}
      </span>
      {hasPermission && (
        <div className={styles.requestItem__actions}>
          <button
            className={`${styles.requestItem__actionBtn} ${!canApprove ? styles['requestItem__actionBtn--disabled'] : ''}`}
            onClick={canApprove ? onApprove : undefined}
            disabled={!canApprove}
            aria-label="Approve request"
          >
            <ApproveIcon className={styles.requestItem__approveIcon} />
          </button>
          <button
            className={`${styles.requestItem__actionBtn} ${!canReject ? styles['requestItem__actionBtn--disabled'] : ''}`}
            onClick={canReject ? onReject : undefined}
            disabled={!canReject}
            aria-label="Reject request"
          >
            <RejectIcon className={styles.requestItem__rejectIcon} />
          </button>
        </div>
      )}
    </div>
  );
};
